AUI().ready(
    /*
	This function gets loaded when all the HTML, not including the portlets, is
	loaded.
	*/

    function () {}
);

Liferay.Portlet.ready(
    /*
	This function gets loaded after each and every portlet on the page.

	portletId: the current portlet's id
	node: the Alloy Node object of the current portlet
	*/

    function (_portletId, _node) {}
);

Liferay.on(
    "allPortletsReady",

    /*
	This function gets loaded when everything, including the portlets, is on
	the page.
	*/

    function () {
        // Search
        $(".icon-search, .icon-remove").click(() => {
            $(".bootsnipp-search").toggleClass("d-flex");
            $(".js-nav-items").toggleClass("d-none");
            $(".bootsnipp-search .portlet-body .search-bar-keywords-input").focus();
            $(".bootsnipp-search .portlet-body .search-bar-keywords-input").attr("placeholder", "What are you looking for?");
        });

        // Mobile Accordion
        $(".accordion-link").click(function () {
            const accordionHref = $(this).attr("href");
            $(".tab-pane").removeClass("active show");
            $(accordionHref).addClass("active show");
            $(".nav-tabs .nav-item .nav-link").removeClass("active");
            $(`a[href*="${accordionHref}"`).addClass("active");
        });

        // Toggle Mobile Navigation Menu
        $(document).ready(function () {
          $(".footer").removeClass("has-shifted");
        });
        
        $("#menu-nav").click(() => {
          if (!$("#ag-mobile, #content").hasClass("show-nav")) {
            $("#ag-mobile, #content").addClass("show-nav");
            $("body").addClass("has-sidebar");
            $(".footer").addClass("has-shifted");
          } else {
            $("#ag-mobile, #content").removeClass("show-nav");
            $("body").removeClass("has-sidebar");
            $(".footer").removeClass("has-shifted");
          }
        });
    
        // Toggle Mobile Login Menu
        $("#login-nav, #js-login-back").click(() => {
          if (!$("#ag-mobile, #content").hasClass("show-login-nav"))
            $("#ag-mobile, #content").addClass("show-login-nav");
          else $("#ag-mobile, #content").removeClass("show-login-nav");
        });
    
        // Toggle Navigation Menu For Explore
        $(".explore-topper").click(() => {
          $("#nav-container").toggleClass("show");
        });

        // Hide Announcement
        $("#ag-notify-ok").click(function () {
            $(".ag-bar").animate({ height: "toggle" }, "slow");
            return !1;
        });

        // Sign in
        $(".dropdown-submenu a.dropdown-link").on("click", function (e) {
            $(this).next("ul").toggle();
            e.stopPropagation();
            e.preventDefault();
        });
    }
    
);

Liferay.on('sessionExpired', function () {
    window.location.href = guestURLthemeConfigValue;
});


/* This function used for redirect to a url */
function redirectTo(redirectPath) {
  console.log("redirectTo: " + redirectPath);
  window.location=redirectPath;
}
function redirectToNewTab(redirectPath) {
  console.log("--> RedirectTo: " + redirectPath);
  window.open(redirectPath, '_blank');
}
function redirectToNewTab(redirectPath, target) {
  console.log("--> RedirectTo: " + redirectPath + ", Target: " + target);
  window.open(redirectPath, target);
}
